import React from "react";
import { Link } from "react-router-dom";
import pin from "../../../assets/images/pin.svg";
import { datas } from "../../../data/data";
import { HiArrowRight } from "react-icons/hi";

function FeaturedWorks() {
  return (
    <section className="bg-bg-white w-full bg-cover  ">
      <div className="container mx-auto pt-[34px] pb-[64px] md:py-[100px]">
        <div className="flex items-center flex-col">
          <div className="flex items-center justify-center">
            <h3 className="font-sfprobold md:text-5xl text-[28px] font-bold md:pr-8 pr-5">
              Featured Works
            </h3>
            <img
              src={pin}
              className="md:h-[64px] md:w-[64px] h-[44px] w-[44px] object-cover pointer-events-none"
              alt="Pin"
            />
          </div>
          <p className="pt-[8px] text-[18px] text-center md:w-full w-[80%]">
            Here are some of our featured works from several services we offer
          </p>
          <div className="mt-[48px] md:mt-6">
            <Link
              to="/our-works/"
              className={`ease-in-out duration-300 rounded-[600px] flex items-center justify-center bg-black md:px-8 md:py-4 py-3 px-6`}
            >
              <span className={`text-white font-bold font-sfpro`}>See all</span>
              <HiArrowRight size={20} className={`text-white ml-2`} />
            </Link>
          </div>
        </div>
        <div className="mt-[48px] md:grid md:grid-cols-2 items-center gap-12 flex flex-col md:w-full w-11/12 mx-auto">
          {datas.slice(0, 6).map((data, i) => (
            <Link
              to={`/our-works/${data.slug}`}
              key={i}
              className="w-full md:h-[500px] cursor-pointer h-[216px] md:card-shadow mb-[80px] rounded-[4px] card-shadow-mobile"
              data-aos={(i + 1) % 2 ? "zoom-in-up" : "zoom-in-down"}
              data-aos-duration="800"
            >
              <div className=" w-full h-full mb-6 rounded-[4px] ">
                <img
                  src={data.heroBg}
                  className="object-cover rounded-[4px] w-full h-full"
                  alt={data.title}
                />
              </div>

              <div className="px-[12px]">
                <h3 className="text-[16px] leading-[22px] md:text-[28px] md:leading-[36px] font-sfprobold md:pt-5 pt-[18px] pb-[5px] text-black">
                  {data.title}
                </h3>
                <p className="text-[14px] leading-[22px] md:text-[18px] md:leading-[28px] font-sfpro text-black opacity-70">
                  {data.sub}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedWorks;
